export default "__VITE_ASSET__BrONT3sY__"